import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "dashboard",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.DASHBOARD.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.DASHBOARD.PERMISSIONS,
    },
    component: () => import("@/modules/Dashboard/views/Dashboard.vue"),
  },
];

export default routes;
